import { Form, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { getLanguage } from "auth-provider";
import { useEffect, useState } from "react";
import { LabelType } from "screens/register/page-header";
import {
  BtnText,
  formPlaceholder,
  VerifyTipConfig,
} from "screens/register/contant";
import { DrawForm } from "./form-utils";
import { getErrorMsg, useHttp } from "utils/http";
import {
  AUTH_API_URL,
  StorageMobile,
  useProjectModal,
} from "screens/register/util";
import { UserPhoneQueryKey } from "utils/oauth";
import { useQueryClient } from "react-query";
import parsePhoneNumberFromString, {
  isValidPhoneNumber,
} from "libphonenumber-js";
import { defaultHeaders } from "utils/request";
import "../register/customize.css";
import { SubmitButton, TipMsg } from "./join-member-form";
import {
  MIX_PANEL_EVENT,
  trackMixPanel,
  useTrackCommonData,
} from "mixpanel/mixpanelTrackUtil";
import { getFormatNumber, slicePhoneNumber } from "utils";
import { useAuth } from "context/auth-context";

export const LoginForm = ({
  setPhone,
  setHeight,
}: {
  setPhone: (phone: string) => void;
  setHeight: (height: string) => void;
}) => {
  const client = useHttp();
  const queryClient = useQueryClient();
  const { open } = useProjectModal();

  const lang = getLanguage() as LabelType;

  const [btnDisabled, setIsEnable] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [formData, setFormData] = useState({ phone: "" });
  const [isLoading, setIsLoading] = useState(false);
  const { restaurant: restaurantData } = useAuth();

  const trackCommonData = useTrackCommonData();

  const handleChange = (e: any) => {
    const inputVal = e.target.value.trim();
    setFormData({ ...formData, phone: inputVal });
    // 计算
    setIsEnable(!inputVal);
    if (inputVal) {
      setErrorMsg("");
    }
  };

  const errorMsgNotify = (description: string) => {
    if (lang === "en") {
      setErrorMsg(description);
      return;
    }
    // 中文提示
    if (description === VerifyTipConfig.phoneError.en) {
      setErrorMsg(VerifyTipConfig.phoneError.zh);
    } else if (VerifyTipConfig.phoneError2.en) {
      setErrorMsg(VerifyTipConfig.phoneError2.zh);
    } else {
      setErrorMsg(description);
    }
  };

  const onFinish = (values: any) => {
    if (btnDisabled || isLoading) return;
    // 手动输了前缀 ;验证手机号不通过
    if (!isValidPhoneNumber(values.phone, "US")) {
      setErrorMsg(VerifyTipConfig.error[lang]);
      setIsEnable(true);
      return;
    }
    const numWithPrefix = getFormatNumber(values.phone) + "";
    // 验证手机号通过
    setErrorMsg("");
    setIsLoading(true);
    trackMixPanel(MIX_PANEL_EVENT.LOGIN_SEND_PHONE, trackCommonData);
    const restaurantName = (lang === "en" ? restaurantData?.data?.attributes?.name : restaurantData?.data?.attributes?.foreign_name) || restaurantData?.data?.attributes?.name;
    client(`${AUTH_API_URL}/api/${lang}/v1/visitors/verification_code`, {
      method: "post",
      headers: defaultHeaders,
      data: {
        phone_number: numWithPrefix,
        marketing_source: "RestaurantTech_Loyalty",
        sms_provider_name: `${restaurantName}`,
      },
    })
      .then((data) => {
        trackMixPanel(
          MIX_PANEL_EVENT.LOGIN_SEND_PHONE_SUCCESS,
          trackCommonData
        );
        setIsLoading(false);
        if (!data && !data.success) {
          message.error(VerifyTipConfig.msgError[lang]);
          return;
        }
        StorageMobile("set", numWithPrefix);
        message.success(VerifyTipConfig.msg[lang]);
        queryClient.invalidateQueries(UserPhoneQueryKey);
        queryClient.setQueryData(UserPhoneQueryKey, {
          name: values.name || "Customer",
          phone: numWithPrefix,
        });
        setPhone(
          parsePhoneNumberFromString(`${values.phone}`, {
            defaultCountry: "US",
          })?.formatNational() || ""
        );
        open("verify", "login");
      })
      .catch((e) => {
        setIsLoading(false);
        const msg = getErrorMsg(e);
        errorMsgNotify(msg);
        trackMixPanel(MIX_PANEL_EVENT.LOGIN_SEND_PHONE_FAILED, {
          ...trackCommonData,
          errorMsg: msg,
          mNo: slicePhoneNumber(numWithPrefix),
          errorApi: "api/{lang}/v1/visitors/verification_code",
        });
      });
  };

  const [formRef] = useForm();
  useEffect(() => {
    const ins = formRef.getFieldInstance("phone");
    ins.focus();
  }, [formRef]);

  useEffect(() => {
    if (errorMsg === VerifyTipConfig.phoneError.en) {
      setHeight("32rem");
    } else if (errorMsg === VerifyTipConfig.phoneError2.en) {
      setHeight("30rem");
    } else if (errorMsg) {
      setHeight("28rem");
    } else {
      setHeight("24.8rem");
    }
  }, [errorMsg, setHeight]);

  return (
    <DrawForm
      form={formRef}
      layout={"vertical"}
      initialValues={formData}
      onFinish={onFinish}
    >
      {/* 手机号 */}
      <Form.Item
        style={{ marginBottom: "1.6rem" }}
        name={"phone"}
        className={"prefixIpt"}
      >
        <input
          type={"number"}
          name={"phone"}
          placeholder={formPlaceholder.join.phone[lang]}
          autoComplete={"off"}
          style={{ paddingLeft: "6rem" }}
          className={"iptClasses commonIptClass"}
          onChange={(e) => handleChange(e)}
        ></input>
      </Form.Item>
      {errorMsg && <TipMsg>{errorMsg}</TipMsg>}
      <Form.Item style={{ marginTop: "1.6rem", marginBottom: "1rem" }}>
        <SubmitButton
          type={"submit"}
          isDisabled={!!isLoading || btnDisabled}
          lang={lang}
          style={{ width: "100%" }}
        >
          {!isLoading
            ? formPlaceholder.login.btn[lang]
            : BtnText.btnSending[lang]}
        </SubmitButton>
      </Form.Item>
      <div className="concent-box" style={{ "alignItems": "flex-start", "marginBottom": "6px;" }}>
        <input type="checkBox" className="checkBtn" checked={true} style={{ "visibility": 'hidden', 'marginTop': '2px' }} />
        <span className="checkbox_img" style={{ "visibility": "visible", "marginTop": "2px", "backgroundColor": "gray" }}></span>
        {
          lang === 'en' && <span className="en-txt" style={{ "whiteSpace": "pre-line" }}>
            By providing I phone number, I agree to receive one-time passcodes and/or receive status updates via text message from Chowbus. Message and data rates may apply.
          </span>
        }
        {
          lang === 'zh' && <span className="zh-txt" style={{ "whiteSpace": "pre-line" }}>
            我同意接收来自 Chowbus 的一次性验证码或状态更新短信。信息可能会产生短信和流量费用。
          </span>
        }
      </div>

    </DrawForm>
  );
};
